import * as React from 'react';
import { TileLayer } from 'react-leaflet';
import { getTileLayerUrl } from './get-tile-layer-url';
import { useDisplayPreferences } from '../../displayPreferences-context';
export function BuildingNumbersLayer({ revisionId }) {
    const { editableBuildings } = useDisplayPreferences();
    if (editableBuildings !== 'enabled') {
        return null;
    }
    return React.createElement(TileLayer, { key: `numbers-${revisionId}`, url: getTileLayerUrl('number_labels', { rev: revisionId }), minZoom: 17, maxZoom: 19, detectRetina: false });
}
